<template>
	<table class="table-main">
		<thead>
			<tr>
				<th v-for="item in etcList" :key="item.key" v-text="item.th" />
			</tr>
		</thead>
		<tbody>
			<tr>
				<td v-for="item in etcList" :key="item.key">
					<span
						class="link"
						@click="openModal(item.key)"
						v-text="item.value"
					/>
				</td>
			</tr>
		</tbody>
	</table>
</template>
<script>
	export default {
		name: 'CastEtcList',
		props: {
			etcList: {
				type: Array,
				default: [],
			},
			castId: {
				type: Number,
				default: null,
			},
			castTitle: {
				type: String,
				default: '',
			},
		},
		methods: {
			openModal(target) {
				this.$store.commit('modal/toggleModal', {
					id: target,
					params: {
						castId: this.castId,
						castTitle: this.castTitle,
					},
				});
			},
		},
	};
</script>
